<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="closeModalWithCancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Ayuda QR Documento de Control Administrativo</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <h3>¿Qué es el DeCA?</h3>
  <p>
    El <strong>Documento de Control</strong> es un documento de carácter administrativo y
    <strong>obligatorio</strong> que debe acompañar a la carga en el transporte público de mercancías por carretera en
    España con información sobre la mercancía, origen, destino, quién es el cargador contractual y quién el
    transportista efectivo, entre otros datos.
  </p>
  <p>
    <strong
      >Desde el 5 de octubre de 2026 solo será válido el formato electrónico, también denominado por el Ministerio de
      Transportes como DeCA</strong
    >. También puede usarse este formato digital antes de esa fecha.
  </p>
  <h3>¿Para qué es este QR?</h3>
  <p>
    Este código QR
    <strong>permite acceder al Documento electrónico de Control Administrativo</strong> elaborado por OkCargo para esta
    carga.
  </p>
  <p>
    El conductor del vehículo deberá mostrarlo al personal de los Servicios de Inspección del Transporte Terrestre o los
    agentes de la Guardia Civil, policías autonómicas y/o locales competentes si le es solicitado.
  </p>
  <h3>Sanciones</h3>
  <p>
    No mostrar el documento, no elaborarlo o que contenga datos falsos puede conllevar sanciones de hasta 6000 euros
    para el transportista y/o el cargador.
  </p>
</ion-content>
